import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import { orderBy } from 'lodash';
import momentTz from 'moment-timezone';
import Header from '../../components/Header';
import CaseRow from '../../components/CaseRow';
import {
  onGoBack,
  getOrderByCases,
  formatter,
  // SERVER_TIMEZONE
} from '../../common/globals';
import withGoBack from '../../common/withGoBack';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withOnline from '../../common/withOnline';
import withBilledFilter from '../../common/withBilledFilter';
import withTableName from '../../common/withTableName';
import withCaseFilter from '../../common/withCaseFilter';
import withSearchBilledData from '../../common/withSearchBilledData';
import withCalendarFilter from '../../common/withCalendarFilter';
import withUser from '../../common/withUser';
import {
  deleteTableWiseCaseByCaseId,
  filterCase,
  setBilledCases,
  getBilled,
  getTableCaseByCaseId,
  // updateTableCaseByPrimaryId,
  updateCaseByPrimaryId,
  updateTableWiseCaseByCaseId,
  insertComplianceApp,
  getVhnPpcValue,
  getHospitalByCustomerNo
} from '../../utils/db';
import {
  addComplianceAppData,
  cancelCase,
  listSingleCase,
  searchBilledCase,
  updateCase,
  updatePushToACM
} from '../../utils/utils';
import Bugsnag from '../../helpers/bugsnag';
import CaseChangesNoLonger from '../../components/Models/CasesChangesNoLonger';
import ZeroProductSubmitModal from '../../components/Models/ZeroProductSubmitModal';
import MrnOrPatientIdModal from '../../components/Models/MrnOrPatientIdModal';
import RequiredMrnOrPatientId from '../../components/Models/RequiredMrnOrPatientId';
import AlreadySubmittedCase from '../../components/Models/AlreadySubmittedCase';
import CancelCaseModal from '../../components/Models/CancelCaseModal';
import withTeam from '../../common/withTeam';
import withVhnPpcOtherCharge from '../../common/withVhnPpcOtherCharge';
import VhnPpcModal from '../../components/Models/VhnPpcModal';
import VrasPpcModal from '../../components/Models/VrasPpcModal';
// import DgrRequiredOnSubmitCase from '../../components/Models/DgrRequiredOnSubmitCase';
import AcmPushCaseConfirmModal from '../../components/Models/AcmPushCaseConfirmModal';
import AcmPushCaseStatusModal from '../../components/Models/AcmPushCaseStatusModal';
import CustCaseIDModal from '../../components/Models/CustCaseIDModal';
import RequiredCustCaseID from '../../components/Models/RequiredCustCaseID';

class Billed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideAndShowCard: false,
      filterData: {},
      filterCases: {},
      casesList: [],
      totalCases: 0,
      totalAmount: 0,
      casesDetail: [],
      caseDetail: {},
      cancelId: 0,
      acmCases: {},
      acmPushCaseStatusCount: 0,
      acmMessageStatusFlag: [],
      acmMessageStatusMessage: '',
      hospitalUseCustCaseIDStatus: false,
    };
    this.zeroProductSubmitModal = null;
    this.mrnOrPatientModal = null;
    this.requiredmrnOrPatientModal = null;
    this.alreadySubmittedCase = null;
    this.caseChangesNoLonger = null;
    this.cancelCaseModal = null;
    this.vhnPpcModal = null;
    this.vrasPpcModal = null;
    this.dgrRequiredOnSubmitCaseModal = null;
    this.acmPushCaseStatusModal = null;
    this.acmPushCaseConfirmModal = null;
    this.custCaseIDModal = null;
    this.requiredCustCaseIDModal = null;
  }

  componentDidMount() {
    try {
      this.zeroProductSubmitModal = new window.bootstrap.Modal(window.$('#zeroProductSubmitModal'));
      this.mrnOrPatientModal = new window.bootstrap.Modal(window.$('#mrnOrPatientIdModal'));
      this.requiredmrnOrPatientModal = new window.bootstrap.Modal(window.$('#requiredMrnOrPatientId'));
      this.alreadySubmittedCase = new window.bootstrap.Modal(window.$('#alreadySubmittedCase'));
      this.caseChangesNoLonger = new window.bootstrap.Modal(window.$('#CaseChangesNoLongerModal'));
      this.cancelCaseModal = new window.bootstrap.Modal(window.$('#cancelCaseModal'));
      this.vhnPpcModal = new window.bootstrap.Modal(window.$('#vhnPpcModalModal'));
      this.vrasPpcModal = new window.bootstrap.Modal(window.$('#vrasPpcModal'));
      this.dgrRequiredOnSubmitCaseModal = new window.bootstrap.Modal(window.$('#dgrRequiredOnSubmitCaseModal'));
      this.acmPushCaseStatusModal = new window.bootstrap.Modal(window.$('#acmPushCaseStatusModal'));
      this.acmPushCaseConfirmModal = new window.bootstrap.Modal(window.$('#acmPushCaseConfirmModal'));
      this.custCaseModal = new window.bootstrap.Modal(window.$('#custCaseIDModal'));
      this.requiredCustCaseIDModal = new window.bootstrap.Modal(window.$('#requiredCustCaseID'));

      // window.addEventListener('scroll', this._onCasesScroll);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  componentWillUnmount() {
    // window.removeEventListener('scroll', this._onCasesScroll);
  }

  _onCasesScroll = () => {
    window.closeAllCasesMenu();
  }

  _updateCaseList = (caseList, detailUpdate = true) => {
    try {
      const { billedFilter: { sortOrder = '' } } = this.props;
      // const response = sortBy(caseList,
      // ['CaseTime', 'CustomerName', 'SurgeonName', 'PatientID']);
      const response = orderBy(caseList, ['CaseDate', 'CaseTime', 'CustomerName', 'SurgeonName', 'PatientID'],
        ['desc', 'asc', 'asc', 'asc', 'asc']);
      const billedRes = response;
      if (detailUpdate) {
        this.setState({
          casesList: sortOrder === 'asc' ? billedRes.reverse() : billedRes,
          casesDetail: response,
        });
      } else {
        this.setState({
          casesList: sortOrder === 'asc' ? billedRes.reverse() : billedRes,
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickFilter = () => {
    try {
      this._onGoBack();
      browserHistory.push('/billed-filter');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFilter = (data) => {
    try {
      const { filterData } = this.state;
      const { notify, setCaseFilter } = this.props;
      setCaseFilter(filterData);
      for (const value in data) {
        if (data[value] === null || data[value] === undefined || data[value] === '' || data[value] === 'NONE') {
          notify({ type: 'warning', message: 'No data to filter', time: 3 });
          delete data[value];
        }
      }
      this.setState({
        filterData: Object.assign(filterData, data)
      }, () => { this._getBilledCases(); });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  longPressFilter = () => {
    try {
      const { filterData, casesDetail } = this.state;
      let data = [...casesDetail];
      if (Object.keys(filterData).length > 0) {
        if (filterData.hasOwnProperty('SurgeonName')) {
          data = (data.filter((item) => item.SurgeonName === filterData.SurgeonName));
        }
        if (filterData.hasOwnProperty('CustomerName')) {
          data = (data.filter((item) => item.CustomerName === filterData.CustomerName));
        }
        if (filterData.hasOwnProperty('CoverRep')) {
          data = (data.filter((item) => item.CoverRep === filterData.CoverRep));
        }
        if (filterData.hasOwnProperty('ProcedureType')) {
          data = (data.filter((item) => item.ProcedureType === filterData.ProcedureType));
        }
        if (filterData.hasOwnProperty('CaseType')) {
          data = (data.filter((item) => item.CaseType === filterData.CaseType));
        }
        if (filterData.hasOwnProperty('Side')) {
          data = (data.filter((item) => item.Side === filterData.Side));
        }
      }
      const amountSum = data.reduce((sum, { Amount }) => sum + parseInt(Amount, 10), 0);
      this.setState({ casesList: data, totalCases: data.length, totalAmount: amountSum });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRedirect = (path) => {
    try {
      this._onGoBack();
      browserHistory.push(path);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRemoveFilter = async (key) => {
    try {
      const { filterData } = this.state;
      const { caseFilter } = this.props;
      if (filterData.hasOwnProperty(key)) {
        delete filterData[key];
      }
      if (Object.keys(caseFilter).length > 0) {
        this.setState({ filterData: caseFilter }, () => {
          this._onFilter(caseFilter);
        });
      } else {
        this.setState({ filterData });
        await this._onFilter(filterData);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getBilledCases = async () => {
    try {
      const filterKey = ['DateStart',
        'DateEnd',
        'selectSurgeon',
        'selectHospitals',
        'selectedTypes',
        'selectedProcedures',
        'Side',
        'PatientID',
        'selectedRefs',
        'Comments',
        'officeNotes',
        'RepPONumber',
        'RepNotes',
        'MRN'];
      const {
        billedFilter, caseFilter, searchBilledData: { selected, form }
      } = this.props;

      if (selected.selectedTypes === 'NONE') {
        selected.selectedTypes = [];
      }
      if (selected.selectedRefs === 'NONE') {
        selected.selectedRefs = '';
      }
      const searchFilterData = {};

      filterKey.map((key) => {
        const filter = billedFilter.hasOwnProperty(key) ? [...billedFilter[key]] : [];
        if (selected[key]) {
          filter.push(selected[key]);
        }
        if (form[key]) {
          filter.push(form[key]);
        }
        if (caseFilter[key]) {
          filter.push(caseFilter[key]);
        }
        if (key === 'selectedTypes'
          || key === 'selectSurgeon'
          || key === 'selectHospitals'
          || key === 'selectedProcedures'
          || key === 'Side') {
          if (billedFilter.hasOwnProperty(key)) {
            searchFilterData[key] = JSON.stringify([...billedFilter[key]]);
          } else if (caseFilter.hasOwnProperty(key)) {
            searchFilterData[key] = JSON.stringify([caseFilter[key]]);
          } else {
            searchFilterData[key] = JSON.stringify(selected[key]);
          }
        } else if ((key === 'officeNotes' || key === 'Comments') && form[key]) {
          searchFilterData.Comments = form[key];
        } else if (key === 'RepNotes' && form[key]) {
          searchFilterData.RepNotes = form[key];
        } else if (key === 'RepPONumber') {
          searchFilterData.RepPONumber = form.po;
        } else {
          searchFilterData[key] = filter.length ? JSON.stringify([...new Set(filter)]) : filter;
        }
      });

      let filterKeys = [];
      let caseFilterValue = {};
      Object.keys(caseFilter).map((key) => {
        if (caseFilter[key].length > 0) {
          caseFilterValue = Object.assign(caseFilterValue, { [key]: [caseFilter[key]] });
        }
      });

      filterKeys = filterKeys.concat(Object.keys(caseFilterValue), Object.keys(billedFilter));
      filterKeys = [...new Set(filterKeys)];

      filterKeys.map((value) => {
        const longPressFilter = caseFilterValue[value] ? caseFilterValue[value] : [];
        const searchFilter = billedFilter[value] ? billedFilter[value] : [];
        billedFilter[value] = value === 'sortOrder' ? searchFilter : [...longPressFilter, ...searchFilter];
      });

      let uniqueValue = {};
      Object.keys(billedFilter).map((key) => {
        uniqueValue = Object.assign(uniqueValue, { [key]: [...new Set(billedFilter[key])] });
      });

      // API CALL
      this._onSearchBilled(searchFilterData);
      this.setState({ filterCases: uniqueValue });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearchBilled = async (searchFilterData) => {
    const { setLoader, notify } = this.props;
    try {
      setLoader(true);
      searchFilterData.SearchType = 'billed';
      searchFilterData.GetCountOnly = 'N';
      searchFilterData.Hospital = searchFilterData.selectHospitals;
      searchFilterData.AltCaseType = searchFilterData.selectedTypes !== ['NONE'] ? searchFilterData.selectedTypes : '';
      searchFilterData.CoverRep = searchFilterData.selectedRefs;
      searchFilterData.SurgeonName = searchFilterData.selectSurgeon;
      searchFilterData.ProcedureType = searchFilterData.selectedProcedures;
      searchFilterData.DateStart = searchFilterData.DateStart.length > 0
        ? JSON.parse(searchFilterData.DateStart).toString() : '';
      searchFilterData.DateEnd = searchFilterData.DateEnd.length > 0
        ? JSON.parse(searchFilterData.DateEnd).toString() : '';

      await searchBilledCase(searchFilterData).then(async (response) => {
        const { status, message, data } = response;
        if (status) {
          if (data.cases.length > 0) {
            this.setState({
              totalCases: data.totalCases,
              totalAmount: data.totalAmount,
              casesList: data.cases,
              casesDetail: data.cases,
            });
            this._updateCaseList(data.cases, true);
            // Set data in local db
            await setBilledCases(data.cases);
            const billedRes = await getBilled();
            this._updateCaseList(billedRes, true);
            // this.setState({ casesList: sortOrder === 'asc'
            // ? billedRes.reverse() : billedRes });
            setLoader(false);
          } else {
            setLoader(false);
            notify({ type: 'error', message: 'No cases found.', time: 3 });
          }
        } else {
          setLoader(false);
          notify({ type: 'error', message, time: 3 });
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    } finally {
      setLoader(false);
    }
  }

  getFilterCases = async (billedFilter) => {
    try {
      const { filterCases } = this.state;
      const { caseFilter } = this.props;
      let totalAmount = 0;
      let result = await filterCase(billedFilter, 'Billed');
      result = filterCases.hasOwnProperty('sortOrder') ? await getOrderByCases(result, filterCases.sortOrder) : result;
      result.map((item) => {
        totalAmount += Number(item.Amount);
      });
      if (Object.keys(caseFilter).length > 0) {
        this.setState({ filterData: caseFilter }, () => {
          this.longPressFilter();
        });
      } else {
        this.setState({
          casesList: result, casesDetail: result, totalCases: result.length, totalAmount
        });
        this._updateCaseList(result, true);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onUnselectValue = async (key, index) => {
    try {
      const {
        billedFilter, setBilledCaseFilter, caseFilter, setCaseFilter
      } = this.props;
      const { filterCases } = this.state;
      if (filterCases[key].length > 1) {
        filterCases[key].splice(index, 1);
        billedFilter[key].splice(index, 1);
      } else {
        delete billedFilter[key];
        delete caseFilter[key];
        delete filterCases[key];
      }
      setBilledCaseFilter(billedFilter);
      setCaseFilter(caseFilter);
      this.setState({ filterCases });
      await this._getBilledCases();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _goBack = () => {
    try {
      const {
        goBack, setBilledCaseFilter, setCaseFilter, setCalendarFilter
      } = this.props;
      setBilledCaseFilter({});
      setCaseFilter({});
      setCalendarFilter({});
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCaseCancel = async () => {
    try {
      const {
        notify, setLoader, online, tableName
      } = this.props;
      const { cancelId } = this.state;
      const caseRes = await getTableCaseByCaseId(cancelId, tableName);
      if (caseRes && caseRes.DGR === '1') {
        setLoader(true);
        this.caseChangesNoLonger.show();
        setLoader(false);
        return;
      }

      if (online) {
        const cancelCaseRes = await cancelCase(caseRes.CaseScheduleID);
        const { message, status } = cancelCaseRes;
        if (status) {
          setLoader(true);
          await deleteTableWiseCaseByCaseId(caseRes.id, tableName);
          await this._getBilledCases();
          if (message.length > 0) {
            // notify({ type: 'success', message });
          }
          // browserHistory.push('/manage-cases');
        } else {
          notify({ type: 'error', message, time: 3 });
        }
        setLoader(false);
      } else {
        setLoader(true);
        await deleteTableWiseCaseByCaseId(caseRes.id, tableName);
        await this._getBilledCases();
        // browserHistory.push('/manage-cases');
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCancel = async (id) => {
    try {
      this.setState({ cancelId: id });
      this.cancelCaseModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCancelCaseBack = () => {
    try {
      this.cancelCaseModal.hide();
      this.setState({ acmCases: {} });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGetACMCase = async (id) => {
    try {
      const { tableName } = this.props;
      const acmCase = await getTableCaseByCaseId(id, tableName);
      if (acmCase.ACMCaseID !== null) {
        return this.setState({ acmCases: acmCase });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmitCase = async (id) => {
    try {
      const {
        notify, online, setLoader, tableName, user: { name }
        // team: { dgrRequired }
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      this.setState({
        caseDetail
      });

      if (online) {
        // if ((caseDetail.case_products.length > 0 || caseDetail.case_dgrs.length === 0)
        //   && caseDetail.ProductSubmitted === '0' && dgrRequired === 6
        //   && caseDetail.case_dgrs.length === 0) {
        //   // notify({ type: 'error',
        //   // message: 'A DGR must be uploaded for this case before it can be submitted.' });
        //   this.dgrRequiredOnSubmitCaseModal.show();
        //   return;
        // }
        if (caseDetail.case_products.length >= 0 && caseDetail.ProductSubmitted === '0') {
          this.zeroProductSubmitModal.show();
        } else {
          let responseJson = {};
          const {
            CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
            PatientID, ProcedureType, CaseType, Side, Comments, RepNotes, ProductNotes,
            ProductSubmitted, RepPONumber, Submitted, CoverRep, ChangeRep, DGRUpload,
            MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
            case_dgrs, case_products,
            ...partialObject
          } = caseDetail;
          const subset = {
            CaseScheduleID,
            CaseDate,
            CaseTime,
            CustomerNo,
            CustomerName,
            SurgeonName,
            PatientID,
            ProcedureType,
            CaseType,
            Side,
            Comments,
            RepNotes,
            ProductNotes,
            ProductSubmitted,
            RepPONumber,
            Submitted,
            CoverRep,
            ChangeRep: name,
            DGRUpload,
            MRN,
            Gender,
            Age,
            ACMPlannedParts,
            ACMSelectedParts,
            Height,
            Weight,
            selectedSets
          };

          const newArrayOfObj = partialObject.case_sets.map(({
            CasePlanId: CasePlanID,
            ...rest
          }) => ({
            CasePlanID,
            ...rest
          }));
          subset.selectedSets = newArrayOfObj;
          subset.Submitted = '1';
          subset.ProductSubmitted = (((case_dgrs.length > 0 || case_products.length > 0) && (subset.ProductSubmitted === '0')) ? '1'
            : ((case_dgrs.length > 0 || case_products.length === 0) && (subset.ProductSubmitted === '1')) ? '1' : null);
          // subset.ProductSubmitted = (((case_dgrs.length > 0 || case_products.length >= 0)
          // && (subset.ProductSubmitted === '0')) ? '1' : null);
          setLoader(true);
          await updateCase(subset);
          responseJson = await listSingleCase(caseDetail.CaseScheduleID);
          const { message, status } = responseJson;
          if (status) {
            const caseDetails = responseJson.data[0];
            caseDetails.id = parseInt(caseDetail.id, 10);
            caseDetails.CaseDate = caseDetail.CaseDate;
            caseDetails.CaseTime = caseDetail.CaseTime;
            // Update the response when update API change
            updateTableWiseCaseByCaseId(caseDetails.RepCaseNo, caseDetails, tableName);
            await this._getBilledCases();
          } else {
            notify({ type: 'error', message });
          }
        }
      } else {
        // caseDetail.Sync = 1;
        // caseDetail.Submitted = '1';
        // caseDetail.ProductSubmitted = '1';
        // updateCaseByPrimaryId(caseDetail.id, caseDetail);
        // setLoader(false);
        notify({
          type: 'error',
          message: 'You must have an internet connection. Please check your connection and try again.',
          time: 3
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOpenMrnPatientIdModal = async (id) => {
    try {
      const {
        tableName
      } = this.props;

      const caseRes = await getTableCaseByCaseId(id, tableName);

      if (typeof caseRes.CustomerNo !== 'undefined' && caseRes.CustomerNo !== null) {
        const hosptalRes = await getHospitalByCustomerNo(caseRes.CustomerNo);

        if (
          hosptalRes.UseCustCaseID === '1'
          && caseRes.CustCaseID === null
          && (caseRes.ProductSubmitted === null || caseRes.ProductSubmitted !== '1')
        ) {
          this.setState({
            hospitalUseCustCaseIDStatus: true
          });
        }
      }

      this.setState({
        mrnOrPatientCaseId: id
      });

      this.mrnOrPatientModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOpenCustomerCaseModal = async (id) => {
    try {
      const {
        tableName
      } = this.props;

      this.setState({
        mrnOrPatientCaseId: id
      });

      const caseRes = await getTableCaseByCaseId(id, tableName);

      if (typeof caseRes.CustomerNo !== 'undefined' && caseRes.CustomerNo !== null) {
        const hosptalRes = await getHospitalByCustomerNo(caseRes.CustomerNo);

        if (
          hosptalRes.UseCustCaseID === '1'
          && caseRes.CustCaseID === null
          && (caseRes.ProductSubmitted === null || caseRes.ProductSubmitted !== '1')
        ) {
          this.setState({
            hospitalUseCustCaseIDStatus: true
          });

          this._onCustomerCaseIDStatus();
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCustomerCaseIDStatus = () => {
    try {
      const custCaseIDStatus = new window.bootstrap.Modal(window.$('#custCaseIDModal'));
      custCaseIDStatus.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onNextCustomerCaseIDStatus = () => {
    try {
      const custCaseIDStatus = new window.bootstrap.Modal(window.$('#requiredCustCaseID'));
      custCaseIDStatus.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onCaseSubmitted = () => {
    try {
      this.alreadySubmittedCase.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmitProductCaseNo = () => {
    try {
      this.zeroProductSubmitModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onNextAddPatientIdOrMrn = () => {
    try {
      this.requiredmrnOrPatientModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddPatientIdOrMrn = () => {
    try {
      this.mrnOrPatientModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddVhnPpc = async (id) => {
    try {
      const { tableName, setLoader } = this.props;
      const { mrnOrPatientCaseId } = this.state;
      let caseDetail = {};
      if (id === undefined) {
        caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      } else {
        caseDetail = await getTableCaseByCaseId(id, tableName);
        this.setState({ mrnOrPatientCaseId: id });
      }
      if (caseDetail.VelysUsed === null) {
        this.vhnPpcModal.show();
        setLoader(false);
      } else if (caseDetail.case_products.length > 0) {
        browserHistory.push(`/manage-case/${id}/products/list`);
        setLoader(false);
      } else {
        browserHistory.push(`/manage-case/${id}/products/add`);
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVhnPpcYes = async () => {
    try {
      const {
        tableName, setVhnPpcOtherCharge, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        vhnPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      }

      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VHN_PPC === '1' ? 'VHN-PPC' : 'VHN-Other',
        UserResponse: 'YES',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? '0' : '1'
      };
      setLoader(true);
      setVhnPpcOtherCharge(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'YES';
              await updateCase(caseDetail);
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
              if (complainAppData.ComplianceType === 'VHN-PPC') {
                this._onGoBack();
                browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add/other-charge`);
              } else {
                browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
              }
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        caseDetail.VelysUsed = 'YES';
        caseDetail.Sync = 1;
        updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
        if (complainAppData.ComplianceType === 'VHN-PPC') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add/other-charge`);
        } else {
          browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
        }
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVhnPpcNo = async () => {
    try {
      const {
        tableName, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        vhnPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      }

      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VHN_PPC === '1' ? 'VHN-PPC' : 'VHN-Other',
        UserResponse: 'NO',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? '0' : '1'
      };
      setLoader(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              this._onGoBack();
              browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        this._onGoBack();
        browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add/other-charge`);
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddVrasPpc = async (id) => {
    try {
      const { tableName, setLoader } = this.props;
      const { mrnOrPatientCaseId } = this.state;
      let caseDetail = {};
      if (id === undefined) {
        caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      } else {
        caseDetail = await getTableCaseByCaseId(id, tableName);
        this.setState({ mrnOrPatientCaseId: id });
      }
      if (caseDetail.VelysUsed === null) {
        this.vrasPpcModal.show();
        setLoader(false);
      } else if (caseDetail.case_products.length > 0) {
        browserHistory.push(`/manage-case/${id}/products/list`);
        setLoader(false);
      } else {
        browserHistory.push(`/manage-case/${id}/products/add`);
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVrasPpcYes = async () => {
    try {
      const {
        tableName, setVhnPpcOtherCharge, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vrasPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        vrasPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      }

      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vrasPpcValue.VRAS_PPC === '1' ? 'VRAS-PPC' : 'VRAS-Other',
        UserResponse: 'YES',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? '0' : '1'
      };
      setLoader(true);
      setVhnPpcOtherCharge(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'YES';
              await updateCase(caseDetail);
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
              if (complainAppData.ComplianceType === 'VRAS-PPC') {
                this._onGoBack();
                browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add/other-charge`);
              } else {
                browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
              }
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        caseDetail.VelysUsed = 'YES';
        caseDetail.Sync = 1;
        updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
        if (complainAppData.ComplianceType === 'VRAS-PPC') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add/other-charge`);
        } else {
          browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
        }
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVrasPpcNo = async () => {
    try {
      const {
        tableName, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vrasPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        vrasPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      }

      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vrasPpcValue.VRAS_PPC === '1' ? 'VRAS-PPC' : 'VRAS-Other',
        UserResponse: 'NO',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? '0' : '1'
      };
      setLoader(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              this._onGoBack();
              browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        this._onGoBack();
        browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onMrnPatientIdAdd = async (formData) => {
    try {
      const {
        notify, online, setLoader, tableName, user: { name }
      } = this.props;
      const { mrnOrPatientCaseId, hospitalUseCustCaseIDStatus } = this.state;
      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vhnPpcValue = {};

      if (caseDetail.CustomerName !== null) {
        vhnPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      }

      if (!Object.keys(formData).length > 0) {
        this._onNextAddPatientIdOrMrn();
        return;
      }

      if (formData.hasOwnProperty('patientId')) {
        caseDetail.PatientID = (formData.patientId !== null || formData.patientId !== undefined)
          ? formData.patientId
          : null;
      }

      if (formData.hasOwnProperty('mrn')) {
        caseDetail.MRN = (formData.mrn !== null || formData.mrn !== undefined)
          ? formData.mrn
          : null;
      }

      if (online) {
        setLoader(true);
        const {
          CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
          PatientID, ProcedureType, CaseType, Side, Comments, RepNotes, ProductNotes,
          ProductSubmitted, RepPONumber, Submitted, CoverRep, ChangeRep, DGRUpload,
          MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
          ...partialObject
        } = caseDetail;
        const subset = {
          CaseScheduleID,
          CaseDate,
          CaseTime,
          CustomerNo,
          CustomerName,
          SurgeonName,
          PatientID,
          ProcedureType,
          CaseType,
          Side,
          Comments,
          RepNotes,
          ProductNotes,
          ProductSubmitted,
          RepPONumber,
          Submitted,
          CoverRep,
          ChangeRep: name,
          DGRUpload,
          MRN,
          Gender,
          Age,
          ACMPlannedParts,
          ACMSelectedParts,
          Height,
          Weight,
          selectedSets
        };
        const newArrayOfObj = partialObject.case_sets.map(({
          CasePlanId: CasePlanID,
          ...rest
        }) => ({
          CasePlanID,
          ...rest
        }));
        subset.selectedSets = newArrayOfObj;
        // subset.selectedSets = caseDetail.case_sets;
        updateCase(subset).then(async (responseJson) => {
          setLoader(false);
          const { status, message } = responseJson;
          if (status) {
            if (Object.keys(formData).length > 0) {
              // notify({ type: 'success', message });
              if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal(caseDetail.id);
                } else {
                  this._onAddVhnPpc();
                }
              } else if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal(caseDetail.id);
                } else {
                  this._onAddVrasPpc();
                }
              } else if (caseDetail.case_products.length > 0) {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal(caseDetail.id);
                } else {
                  this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/list`);
                }
              } else {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal(caseDetail.id);
                } else {
                  this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
                }
              }
            }

            // Update into local db
            updateCaseByPrimaryId(caseDetail.id, caseDetail);
            // setLoader(false);
            this.setState({ caseDetail });
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        caseDetail.Sync = 1;
        this._onGoBack();
        if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal(caseDetail.id);
          } else {
            this._onAddVhnPpc(mrnOrPatientCaseId);
          }
        } else if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal(caseDetail.id);
          } else {
            this._onAddVrasPpc(mrnOrPatientCaseId);
          }
        } else if (caseDetail.case_products.length > 0) {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal(caseDetail.id);
          } else {
            this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/list`);
          }
        } else {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal(caseDetail.id);
          } else {
            this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
          }
        }

        // Update into local db
        updateCaseByPrimaryId(caseDetail.id, caseDetail);
        setLoader(false);
        this.setState({ caseDetail });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCustomerCaseIDAdd = async (formData) => {
    try {
      const {
        notify, online, setLoader, tableName, user: { name }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;
      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vhnPpcValue = {};

      if (caseDetail.CustomerName !== null) {
        vhnPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      }

      if (!Object.keys(formData).length > 0) {
        this._onNextCustomerCaseIDStatus();
        return;
      }

      if (formData.hasOwnProperty('CustCaseID')) {
        caseDetail.CustCaseID = (formData.CustCaseID !== null || formData.CustCaseID !== undefined)
          ? formData.CustCaseID
          : null;
      }

      if (online) {
        setLoader(true);
        const {
          CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
          PatientID, ProcedureType, CaseType, Side, Comments, RepNotes, ProductNotes,
          ProductSubmitted, RepPONumber, Submitted, CoverRep, ChangeRep, DGRUpload,
          MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
          CustCaseID, ...partialObject
        } = caseDetail;
        const subset = {
          CaseScheduleID,
          CaseDate,
          CaseTime,
          CustomerNo,
          CustomerName,
          SurgeonName,
          PatientID,
          ProcedureType,
          CaseType,
          Side,
          Comments,
          RepNotes,
          ProductNotes,
          ProductSubmitted,
          RepPONumber,
          Submitted,
          CoverRep,
          ChangeRep: name,
          DGRUpload,
          MRN,
          Gender,
          Age,
          ACMPlannedParts,
          ACMSelectedParts,
          Height,
          Weight,
          selectedSets,
          CustCaseID,
        };

        const newArrayOfObj = partialObject.case_sets.map(({
          CasePlanId: CasePlanID,
          ...rest
        }) => ({
          CasePlanID,
          ...rest
        }));

        subset.selectedSets = newArrayOfObj;
        updateCase(subset).then(async (responseJson) => {
          setLoader(false);
          const { status, message } = responseJson;
          if (status) {
            if (Object.keys(formData).length > 0) {
              if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
                this._onAddVhnPpc();
              } else if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
                this._onAddVrasPpc();
              } else if (caseDetail.case_products.length > 0) {
                this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/list`);
              } else {
                this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
              }
            }

            // Update into local db
            updateCaseByPrimaryId(caseDetail.id, caseDetail);
            // setLoader(false);
            this.setState({ caseDetail });
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        caseDetail.Sync = 1;
        this._onGoBack();
        if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
          this._onAddVhnPpc(mrnOrPatientCaseId);
        } else if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
          this._onAddVrasPpc(mrnOrPatientCaseId);
        } else if (caseDetail.case_products.length > 0) {
          this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/list`);
        } else {
          this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
        }

        // Update into local db
        updateCaseByPrimaryId(caseDetail.id, caseDetail);
        setLoader(false);
        this.setState({ caseDetail });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCustomerCaseIDBack = async () => {
    try {
      const {
        tableName
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vhnPpcValue = {};

      if (caseDetail.CustomerName !== null) {
        vhnPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      }

      if ((caseDetail.case_products.length > 0
        || caseDetail.case_products.length === 0)
        && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
        this._onAddVhnPpc(mrnOrPatientCaseId);
      } else if ((caseDetail.case_products.length > 0
        || caseDetail.case_products.length === 0)
        && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
        this._onAddVrasPpc(mrnOrPatientCaseId);
      } else if (caseDetail.case_products.length > 0) {
        this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/list`);
      } else {
        // alert(`/manage-case/${mrnOrPatientCaseId}/products/add`);
        this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmitProductCaseYes = async () => {
    try {
      const {
        notify, setLoader, tableName, user: { name }
      } = this.props;

      const { caseDetail } = this.state;
      if (caseDetail && caseDetail.DGR === '1') {
        this.caseChangesNoLonger.show();
        return;
      }
      let responseJson = {};
      const {
        CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
        PatientID, ProcedureType, CaseType, Side, Comments, RepNotes, ProductNotes,
        ProductSubmitted, RepPONumber, Submitted, CoverRep, ChangeRep, DGRUpload,
        MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
        ...partialObject
      } = caseDetail;
      const subset = {
        CaseScheduleID,
        CaseDate,
        CaseTime,
        CustomerNo,
        CustomerName,
        SurgeonName,
        PatientID,
        ProcedureType,
        CaseType,
        Side,
        Comments,
        RepNotes,
        ProductNotes,
        ProductSubmitted,
        RepPONumber,
        Submitted,
        CoverRep,
        ChangeRep: name,
        DGRUpload,
        MRN,
        Gender,
        Age,
        ACMPlannedParts,
        ACMSelectedParts,
        Height,
        Weight,
        selectedSets
      };
      subset.Submitted = '1';
      subset.ProductSubmitted = '1';
      const newArrayOfObj = partialObject.case_sets.map(({
        CasePlanId: CasePlanID,
        ...rest
      }) => ({
        CasePlanID,
        ...rest
      }));
      subset.selectedSets = newArrayOfObj;
      setLoader(true);
      await updateCase(subset);
      setLoader(false);
      responseJson = await listSingleCase(caseDetail.CaseScheduleID);
      const { message, status } = responseJson;
      if (status) {
        const caseDetails = responseJson.data[0];
        caseDetails.id = parseInt(caseDetail.id, 10);
        caseDetails.CaseDate = caseDetail.CaseDate;
        caseDetails.CaseTime = caseDetail.CaseTime;
        // Update the response when update API change
        updateTableWiseCaseByCaseId(caseDetails.RepCaseNo, caseDetails, tableName);
        await this._getBilledCases();
        // updateCaseByPrimaryId(caseDetail.id, caseDetail);
        this.zeroProductSubmitModal.hide();
      } else {
        notify({ type: 'error', message, time: 3 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSmallLargeCard = () => {
    try {
      const { hideAndShowCard } = this.state;
      const { setCalendarFilter } = this.props;
      this.setState({ hideAndShowCard: !hideAndShowCard }, () => {
        setCalendarFilter({ hideAndShowCard: !hideAndShowCard });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getScreenWidth = () => {
    this.setState({ screenWidth: window.screen.width });
  }

  // _onClickDrgModalYes = () => {
  //   try {
  //     const { caseDetail } = this.state;
  //     this._onGoBack();
  //     browserHistory.push(`/manage-case/${caseDetail.id}/products/dgr`);
  //   } catch (e) {
  //     Bugsnag.notify(e);
  //   }
  // }

  _onSubmitACMPushCase = async () => {
    try {
      const {
        notify, online, setLoader, tableName
      } = this.props;
      const { caseDetail } = this.state;

      if (online) {
        let responseJson = {};
        setLoader(true);
        responseJson = await listSingleCase(caseDetail.CaseScheduleID);
        const { message, status } = responseJson;
        if (status) {
          const caseDetails = responseJson.data[0];
          caseDetails.id = parseInt(caseDetail.id, 10);
          caseDetails.CaseDate = caseDetail.CaseDate;
          caseDetails.CaseTime = caseDetail.CaseTime;
          // Update the response when update API change
          updateTableWiseCaseByCaseId(caseDetails.RepCaseNo, caseDetails, tableName);
          await this._getBilledCases();
        } else {
          notify({ type: 'error', message });
        }
      } else {
        notify({
          type: 'error',
          message: 'You must have an internet connection. Please check your connection and try again.',
          time: 3
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onACMPushCase = async (id) => {
    try {
      const {
        notify, online, tableName
      } = this.props;

      if (online) {
        const caseDetail = await getTableCaseByCaseId(id, tableName);
        this.setState({ caseDetail });

        if (caseDetail.ACM === '0') {
          this.setState({
            acmPushCaseStatusCount: 1
          });
          this._onACMPushCaseStatus();
        } else {
          this._onACMPushCaseConfirm();
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onPushCaseYes = async () => {
    try {
      const {
        online,
        notify,
      } = this.props;
      const {
        caseDetail: {
          Age,
          Gender,
          Height,
          HeightUnits,
          PatientID,
          Weight,
          WeightUnits,
          case_xrays,
          MRN,
          Side,
        },
      } = this.state;

      if (online) {
        let xrayCountFlag = 0;
        const xrayStatusFlag = typeof case_xrays !== 'undefined' ? case_xrays.length : 0;
        if (xrayStatusFlag > 0) {
          case_xrays.forEach((element) => {
            if (element.Filename.includes('.dcm')) {
              xrayCountFlag++;
            }
          });
        }

        if (Number(xrayCountFlag) > 0) {
          const MessageStatusFlag = [];
          if ((PatientID === '' || PatientID === null) && (MRN === '' || MRN === null)) {
            MessageStatusFlag.push('Patient or MRN');
          }

          if (Side === '' || Side === null) {
            MessageStatusFlag.push(MessageStatusFlag.length > 0 ? '& Side' : 'Side');
          }

          if (MessageStatusFlag.length > 0) {
            this.setState({
              acmMessageStatusFlag: MessageStatusFlag,
              acmPushCaseStatusCount: 5
            });
            this._onACMPushCaseStatus();
          } else {
            this._updatePushToACM();
          }
        } else {
          const fieldsToCheck = [
            { field: Age, name: 'Age' },
            { field: Gender, name: 'Gender' },
            { field: Height, name: 'Height' },
            { field: HeightUnits, name: 'Height Units' },
            { field: Side, name: 'Side' },
            { field: Weight, name: 'Weight' },
            { field: WeightUnits, name: 'Weight Units' },
          ];

          const MessageStatusFlag = fieldsToCheck.filter(
            ({ field }) => typeof field === 'undefined' || field === null || field === '' || field === '.00'
          )
            .map(({ name }) => name);

          if ((PatientID === '' || PatientID === null) && (MRN === '' || MRN === null)) {
            MessageStatusFlag.push('Patient or MRN');
          }

          if (MessageStatusFlag.length > 0) {
            this.setState({
              acmPushCaseStatusCount: 2,
              acmMessageStatusFlag: MessageStatusFlag.sort()
            });
            this._onACMPushCaseStatus();
          } else {
            this._updatePushToACM();
          }
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _updatePushToACM = async () => {
    try {
      const {
        online,
        notify,
        setLoader,
        user: {
          territories,
          territoryId
        }
      } = this.props;
      const {
        caseDetail: {
          CaseScheduleID
        },
      } = this.state;

      if (online) {
        setLoader(true);
        const pushData = {
          caller: 'OPT'
        };

        territories.map((item) => {
          if (item.id === territoryId) {
            pushData.TerritoryCode = item.abb;
          }
        });

        const acmResponseJson = await updatePushToACM(CaseScheduleID, pushData);
        const { message, status, result } = acmResponseJson;
        setLoader(false);
        if (typeof result !== 'undefined' && result === 'failure') {
        } else {
          if (status) {
            this.setState({
              acmPushCaseStatusCount: 4,
              acmMessageStatusMessage: message
            });
          } else {
            this.setState({
              acmPushCaseStatusCount: 3,
              acmMessageStatusMessage: message
            });
          }

          this._onACMPushCaseStatus();
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onPushCaseStatus = async () => {
    try {
      const {
        online,
        notify,
      } = this.props;
      const { acmPushCaseStatusCount } = this.state;
      if (online) {
        this.setState({
          acmPushCaseStatusCount: 0,
          acmMessageStatusFlag: [],
          acmMessageStatusMessage: ''
        });

        if (acmPushCaseStatusCount === 4) {
          this._onSubmitACMPushCase();
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onPushCaseNo = () => {
    try {
      const {
        online, notify
      } = this.props;
      if (online) {
        this.setState({
          acmPushCaseStatusCount: 0,
          acmMessageStatusFlag: [],
          acmMessageStatusMessage: ''
        });
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onACMPushCaseStatus = () => {
    try {
      const acmPushCaseStatus = new window.bootstrap.Modal(window.$('#acmPushCaseStatusModal'));
      acmPushCaseStatus.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onACMPushCaseConfirm = () => {
    try {
      const acmPushCaseConfirm = new window.bootstrap.Modal(window.$('#acmPushCaseConfirmModal'));
      acmPushCaseConfirm.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        online, notify, setTableName, caseFilter, calendarFilter, user: { isBigCards }
      } = this.props;

      setTableName('Billed');
      await this._getScreenWidth();
      if (caseFilter !== undefined) {
        this.setState({
          filterData: caseFilter,
          hideAndShowCard: isBigCards === true ? false
            : isBigCards === false ? true
              : calendarFilter.hideAndShowCard
        });
      }
      if (online) {
        await this._getBilledCases();
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.',
          time: 3
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      hideAndShowCard,
      casesList,
      totalCases,
      filterCases,
      totalAmount,
      caseDetail,
      acmCases,
      screenWidth,
      acmPushCaseStatusCount,
      acmMessageStatusFlag,
      acmMessageStatusMessage,
    } = this.state;
    const {
      tableName,
      user: {
        scanner, territories, selectedTeam, territoryId
      }
    } = this.props;
    return (
      <div className="site-wrapper resizer-class">
        <Header
          title="Billed"
          goBack={this._goBack}
        />
        <section className="top-filter-section border-top-0 sticky-missing resizer-class">
          <div className="container">
            <div className="row">
              <div className="col">
                <p>Cases: {totalCases}</p>
                <p>Total: {formatter.format(totalAmount)}</p>
              </div>
              <div className="col text-end align-self-center">
                <div className="action">
                  <Link
                    onClick={this._onSmallLargeCard}
                    className="cursor-pointer"
                  >
                    {
                      hideAndShowCard ? 'LARGE CARDS ' : 'SMALL CARDS '
                    }
                  </Link>
                  <Link className="cursor-pointer" onClick={this._onClickFilter}>
                    <i className="fas fa-search" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row gx-1 mt-2">
              <div className="row">
                {
                  (
                    Object.keys(filterCases).map((key) => (
                      key !== 'sortOrder'
                      && filterCases[key].map((item, index) => (
                        <div key={index} className="col-6">
                          <div className="selection selection-sm">
                            <p className="text-ellipsis-filter-ops">{item.toUpperCase()}</p>
                            <button className="btn close-dropdown" onClick={() => this._onUnselectValue(key, index, filterCases[key])}><i className="fas fa-times" /></button>
                          </div>
                        </div>
                      ))
                    ))
                  )
                }
              </div>
            </div>
          </div>
        </section>

        <section
          className={`cards-section pt-0 ${(casesList.length > 0) ? 'resizer-class' : ''}`}
          style={{ paddingBottom: '10px' }}
        >
          <div className="container">
            <div className="row">
              {
                (casesList.length > 0)
                && casesList.map((data, key) => (
                  <CaseRow
                    table={tableName}
                    key={key}
                    keyValue={key}
                    data={data}
                    smallLargeCard={hideAndShowCard}
                    onRedirect={this._onRedirect}
                    onFilter={this._onFilter}
                    onCancel={this._onCancel}
                    onGetACMCase={this._onGetACMCase}
                    onSubmitCase={this._onSubmitCase}
                    onMrnPatientIdAdd={this._onOpenMrnPatientIdModal}
                    onCaseSubmitted={this._onCaseSubmitted}
                    scanner={scanner}
                    territories={territories}
                    selectedTeam={selectedTeam}
                    territoryId={territoryId}
                    screenWidth={screenWidth}
                    addVhnPpc={this._onAddVhnPpc}
                    addVrasPpc={this._onAddVrasPpc}
                    type="billedCaseRow"
                    onACMPushCase={this._onACMPushCase}
                    onCustomerCaseAdd={this._onOpenCustomerCaseModal}
                  />
                ))
                // : <div className="text-center mt-5">No cases found</div>
              }
              <ZeroProductSubmitModal
                onSubmitProductCaseYes={this._onSubmitProductCaseYes}
                onSubmitProductCaseNo={this._onSubmitProductCaseNo}
                caseDetail={caseDetail}
              />
              <MrnOrPatientIdModal onSubmit={this._onMrnPatientIdAdd} />
              <RequiredMrnOrPatientId onClickOk={this._onAddPatientIdOrMrn} />
              <AlreadySubmittedCase />
              <CaseChangesNoLonger
                id={caseDetail.id}
              />
              <CancelCaseModal
                onCancelCase={this._onCaseCancel}
                onCaseRowAcmCase={acmCases}
                onCancelCaseBack={this._onCancelCaseBack}
              />
              <VhnPpcModal
                onClickNo={this._onClickVhnPpcNo}
                onClickYes={this._onClickVhnPpcYes}
              />
              <VrasPpcModal
                onClickNo={this._onClickVrasPpcNo}
                onClickYes={this._onClickVrasPpcYes}
              />
              {/* <DgrRequiredOnSubmitCase */}
              {/*  onClickYes={this._onClickDrgModalYes} */}
              {/* /> */}
              <AcmPushCaseConfirmModal
                onPushCaseYes={this._onPushCaseYes}
                onPushCaseNo={this._onPushCaseNo}
              />
              <AcmPushCaseStatusModal
                messageStatus={acmPushCaseStatusCount}
                onPushCaseStatus={this._onPushCaseStatus}
                acmMessageStatusFlag={acmMessageStatusFlag}
                acmMessageStatusMessage={acmMessageStatusMessage}
              />
              <CustCaseIDModal
                onSubmit={this._onCustomerCaseIDAdd}
                onBack={this._onCustomerCaseIDBack}
              />
              <RequiredCustCaseID onClickOk={this._onCustomerCaseIDStatus} />
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withVhnPpcOtherCharge(
  withUser(
    withCalendarFilter(
      withSearchBilledData(
        withCaseFilter(
          withTableName(
            withBilledFilter(
              withOnline(
                withLoader(
                  withNotify(
                    withGoBack(
                      withTeam(
                        Billed
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
